import React from 'react'
import { useNavigation } from '@react-navigation/native'

const withNavigation = (Component) => (props) => {
  const navigation = useNavigation()

  return <Component navigation={navigation} {...props} />
}
export default withNavigation
